exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tblClass[data-v-3f90c418]{border-collapse:collapse}.tblClass tr td[data-v-3f90c418],.tblClass tr th[data-v-3f90c418]{border:1px solid #ccc;padding:8px 0}.textCenter[data-v-3f90c418],.textCenter tr td[data-v-3f90c418],.textCenter tr th[data-v-3f90c418]{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3f90c418","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/administration/leave_entry/detailsLeave.vue
// module id = 1300
// module chunks = 3